import { render } from "./Languages.vue?vue&type=template&id=3b57d35c&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"

import "./Languages.vue?vue&type=style&index=0&id=3b57d35c&scoped=true&lang=scss"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b57d35c"]])

export default __exports__